import { createAsyncThunk } from '@reduxjs/toolkit'
import { sessionApi } from '@/entities/session'
import { type UserDTO, UserRoleCode } from '@/entities/user'
import { xeroAuthApi } from './xeroLogin'

export const xeroLoginThunk = createAsyncThunk<
	UserDTO,
	{ code: string; state: string },
	{ rejectValue: string }
>(
	'authentication/xero-login',
	async ({ code, state }, { dispatch, rejectWithValue }) => {
		try {
			const data = await dispatch(
				xeroAuthApi.endpoints.xeroCallback.initiate({ code, state })
			).unwrap()

			if (data.role.code === UserRoleCode.SUPERADMIN) {
				dispatch(sessionApi.endpoints.logout.initiate())
				return rejectWithValue("You don't have permission to access this page")
			}

			return data
		} catch (err) {
			if (typeof err === 'string') {
				return rejectWithValue(err)
			}
			return rejectWithValue('Xero authentication failed')
		}
	}
)
